import { useEffect, useRef, useState } from "react";

export function useStickyLoading(active: boolean, opts?: { showDelay?: number; minVisible?: number }) {
  const showDelay = opts?.showDelay ?? 150;   // ms chờ trước khi show loading
  const minVisible = opts?.minVisible ?? 300; // ms tối thiểu hiển thị loading

  const [visible, setVisible] = useState(false);
  const shownAtRef = useRef<number | null>(null);
  const delayId = useRef<number | null>(null);
  const hideId = useRef<number | null>(null);

  useEffect(() => {
    // clear
    if (delayId.current) { clearTimeout(delayId.current); delayId.current = null; }
    if (hideId.current) { clearTimeout(hideId.current); hideId.current = null; }

    if (active) {
      // đợi 150ms mới show
      delayId.current = window.setTimeout(() => {
        setVisible(true);
        shownAtRef.current = Date.now();
      }, showDelay);
    } else {
      if (visible && shownAtRef.current) {
        const elapsed = Date.now() - shownAtRef.current;
        const remain = Math.max(0, minVisible - elapsed);
        hideId.current = window.setTimeout(() => {
          setVisible(false);
          shownAtRef.current = null;
        }, remain);
      } else {
        setVisible(false);
      }
    }

    return () => {
      if (delayId.current) clearTimeout(delayId.current);
      if (hideId.current) clearTimeout(hideId.current);
    };
  }, [active, showDelay, minVisible, visible]);

  return visible;
}
